<template>
	<div>
		<div class="vue-quill-editor-container" @click="handleImageClick">
			<div class="vue-quill-editor" :class="{ focused: focused }">
				<quill-editor
					:ref="`editors_${id}`"
					v-model="contentCopy"
					:options="editorOptions"
					@focus="onFocus"
					@blur="onBlur"
					@input="updateContent"
					@ready="onEditorReady"
					:sanitize="false"
					class="border-top"
				></quill-editor>
			</div>
			<span
				class="placeholder"
				:class="{ active: !focused && contentCopy == '' }"
				v-text="contentCopy ? placeholder : placeholder"
        :style="{ background: !placeholder ? 'transparent' : 'white' }"
				@click="focusEditor()"
			></span>
		</div>
		<!--		<upload-->
		<!--			:fileListShow="false"-->
		<!--			@customUpload="richTextContentMultiple(fillIn, $event)"-->
		<!--			:accept="fileAccept"-->
		<!--			:deleteUpload="deleteUpload"-->
		<!--			:fileUrlData="urlData"-->
		<!--		>-->
		<!--			<el-button type="text" title="图片" @click="fileAccept = 'image'">-->
		<!--				&lt;!&ndash; <font-awesome-icon icon="image" /> &ndash;&gt;-->
		<!--				<img :src="require('@/assets/image/img.png')" width="20px" height="20px" />-->
		<!--			</el-button>-->
		<!--			<el-button type="text" title="视频" @click="fileAccept = 'video'">-->
		<!--				&lt;!&ndash; <font-awesome-icon icon="play-circle" /> &ndash;&gt;-->
		<!--				<img :src="require('@/assets/image/video.png')" width="20px" height="20px" />-->
		<!--			</el-button>-->
		<!--			<el-button type="text" title="音频" @click="fileAccept = 'audio'">-->
		<!--				&lt;!&ndash; <font-awesome-icon icon="volume-up" /> &ndash;&gt;-->
		<!--				<img :src="require('@/assets/image/audio.png')" width="20px" height="20px" />-->
		<!--			</el-button>-->
		<!--			<el-button type="text" @click.stop="insertLight">-->
		<!--				{{ `添加填空` }}-->
		<!--			</el-button>-->
		<!--		</upload>-->
		<el-button type="text" title="图片" @click="popup('image')">
			<img :src="require('@/assets/image/img.png')" width="20px" height="20px" alt="图片" />
		</el-button>
		<el-button type="text" title="视频" @click="popup('video')">
			<img :src="require('@/assets/image/video.png')" width="20px" height="20px" alt="视频" />
		</el-button>
		<el-button type="text" title="音频" @click="popup('audio')">
			<img :src="require('@/assets/image/audio.png')" width="20px" height="20px" alt="音频" />
		</el-button>
		<el-button type="text" @click.stop="insertLight">
			{{ `添加填空` }}
		</el-button>

		<el-dialog
			custom-class="video-dialog"
			:show-close="false"
			:before-close="closeAudio"
			:visible.sync="audioFlag"
			:append-to-body="true"
			:width="'350px'"
			top="40vh"
		>
			<div style="display: flex; justify-content: center; z-index: 2099; position: relative; margin-bottom: 10px;">
				<i
					class="el-icon-close"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="audioFlag = false"
				></i>
				<audio ref="audioPlayer" @click.stop controls :src="audioResource" controlslist="noplaybackrate nodownload"></audio>
			</div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="fillInFlag" width="50%" class="dialog">
			<span slot="title" class="dialog-title">
				<i class="el-icon-warning-outline" style="margin-right: 12px;"></i>编辑填空
			</span>
			<div class="fill-in-input" v-for="(item, index) in fillInText" :key="index">
				<el-input placeholder="请输入填空答案" v-model="fillInText[index]">
					<i slot="suffix" class="el-icon-delete" @click="fillInTextClear(index)"></i>
				</el-input>
			</div>
			<i class="el-icon-circle-plus" @click="fillInText.push('')"></i>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="fillInFlag = false" :disabled="loading">取 消</el-button> -->
				<el-button type="primary" @click="saveEditEvent">保存填空</el-button>
			</span>
		</el-dialog>
		<el-dialog
			custom-class="video-dialog"
			:show-close="false"
			:visible.sync="videoFlag"
			:append-to-body="true"
			:width="'509px'"
			:before-close="closeVideo"
			top="32vh"
		>
			<div style="display: flex; justify-content: center; z-index: 2099; position: relative;">
				<i
					class="el-icon-close"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="videoFlag = false"
				></i>
				<video
					ref="videoPlayer"
					@click.stop
					controls
					width="500"
					style="max-height: 500px;"
					:src="videoResource"
					controlslist="noplaybackrate nodownload"
				></video>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="imgFlag" :append-to-body="true" width="620px">
			<div style="display: flex; justify-content: center; padding: 10px;">
				<img :src="imgResource" style="max-width: 600px; max-height: 900px;" />
			</div>
		</el-dialog>
    <div ref="dialogRefBox"></div>
	</div>
</template>
<script>
import upload from './VisualQuestionEditor/upload.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import { ImageBlot, FillIn, setThis } from './ImageBlot.js'
import { spansText, spansTextEmpty } from './RegExp'
import { debounce } from 'lodash'
import uuid from '@/utils/uuid'
import { tikuManager } from '@/observable'
import validateCommon from '@/components/ResourceDialog/validateCommon.js'
import { ResourcesDialogShadowElement } from 'file-explorer'
Quill.register(ImageBlot, true) // 插入图片
Quill.register(FillIn, true) // 插入文本
// Quill.register(IconBlot, true) // 插入图标

export default {
	components: {
		upload,
		quillEditor
	},
	props: {
		richType: {
			type: String,
			default: 'edit'
		},
		placeholder: {
			type: String,
			default: '项目A'
		},
		content: {
			type: String,
			default: ''
		}
	},
	watch: {
		content: {
			handler() {
				this.contentCopy = this.content
				if (this.contentCopy) this.focused = true
			},
			immediate: true
		}
	},
	computed: {
		tikuManager() {
			return tikuManager
		},
    currentActiveIdObj() {
      return tikuManager.objIdData[tikuManager.activeID]
    },
	},
	data() {
		return {
			style: {},
			id: uuid(),
			imgFlag: false,
			audioFlag: false,
			videoFlag: false,
			videoResource: '',
			audioResource: '',
			imgResource: '',
			editorOptions: {
				modules: {
					toolbar: [],
					clipboard: {
						matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]]
					}
				},
				placeholder: '项目A'
			},
			contentCopy: '',
			fileAccept: '',
			urlData: [],
			fillIn: 'fillIn',
			fillInFlag: false,
			focused: false,
			fillInText: '' | [],
			node: null,
			loading: false,
			timer: null,
			nowTime: new Date().getTime(),
      closeDialog: undefined
		}
	},
	methods: {
		closeAudio() {
			if (this.$refs.audioPlayer) {
				this.$refs.audioPlayer.pause()
				this.$refs.audioPlayer.currentTime = 0
			}
			this.audioFlag = false
		},
		closeVideo() {
			if (this.$refs.videoPlayer) {
				this.$refs.videoPlayer.pause()
				this.$refs.videoPlayer.currentTime = 0
			}
			this.videoFlag = false
		},
		onEditorReady(editorInstance) {},
		// 禁用cv图片，文本样式清洗，会影响插入之后的图片回显~头疼
		handleCustomMatcher(node, delta) {
			if (!this.loading && this.richType !== 'new') {
				clearTimeout(this.timer)
				this.timer = setTimeout(() => {
					this.loading = true
				}, this.nowTime + 3000 - new Date().getTime())
				return delta
			}
			const opsList = []
			delta.ops.forEach(op => {
				if (op.insert && typeof op.insert === 'string') {
					opsList.push({
						insert: op.insert
					})
				} else if (op.insert?.span) {
					opsList.push({
						insert: op.insert.span.content
					})
				} else if (op.insert?.image?.data == null) {
					this.$message('禁止复制图片')
				}
			})
			delta.ops = opsList
			return delta
		},
		async insertLight() {
			await this.richTextContentMultiple({ fileType: 'span' })
		},
		async richTextContentMultiple(e) {
			let quillEditor = this.$refs[`editors_${this.id}`].quill
			return await this.insertEmbed({ quillEditor, ...e })
		},
		onBlur() {
			// if (!this.contentCopy) {
			this.focused = false
			// }
			// 失去焦点关闭音频标签
			this.audioFlag = false
			this.videoFlag = false
		},
		async insertEmbed({ quillEditor, response, fileType, content = '填空答案' }) {
			// if (this.insertingFlag) {
			// 	return
			// }
			let index = quillEditor.getSelection()?.index || quillEditor.selection?.savedRange?.index || 0
			const uri = response?.uri
			// this.insertingFlag = true
			await new Promise(reslove => {
				switch (fileType) {
					case 'image':
						quillEditor.insertEmbed(index, 'image', {
							style: 'width:50px;height:50px;display:inline-block;position:relative',
							url: uri,
							type: 'image',
							data: uri
            })
            quillEditor.insertText(quillEditor.getLength(), ' ', 'silent') // 插入资源后，静默插入一个空格，缺失这个空格的话，会导致中文输入法输入时，重复第一个字符
						reslove()
						break
					case 'video':
						quillEditor.insertEmbed(index, 'image', {
							style: 'width:20px;height:20px;display:inline-block;position:relative',
							url: require('@/assets/image/video.png'),
							data: uri,
							type: 'video'
            })
            quillEditor.insertText(quillEditor.getLength(), ' ', 'silent') // 插入资源后，静默插入一个空格，缺失这个空格的话，会导致中文输入法输入时，重复第一个字符
						// quillEditor.clipboard.dangerouslyPasteHTML(
						// 	index,
						// 	'<b id="video1" data-id="video1" style="color:red" onclick="function(){ console.log(1) }">World</b>'
						// )
						// index = quillEditor.getSelection()?.index + 1
						// quillEditor.setSelection(index)
						reslove()
						break
					case 'audio':
						quillEditor.insertEmbed(index, 'image', {
							style: 'width:20px;height:20px;display:inline-block;position:relative',
							url: require('@/assets/image/audio.png'),
							data: uri,
							type: 'audio'
            })
            quillEditor.insertText(quillEditor.getLength(), ' ', 'silent') // 插入资源后，静默插入一个空格，缺失这个空格的话，会导致中文输入法输入时，重复第一个字符
						reslove()
						break
					case 'span':
						// quillEditor.insertText(index, '这里是填空题答案', {
						// 	'color': '#FF5E2A',
						//   'underline': true,
						//   'clean': true
						// }, new Date().getTime())
						quillEditor.insertEmbed(index, 'span', {
							content: content
						})
						// index = quillEditor.getSelection()?.index + 1
						// quillEditor.setSelection(index)
						reslove()
						break
					default:
						reslove()
				}
			})
			quillEditor.focus()
			quillEditor.insertText(quillEditor.getLength(), '', 'user')
			quillEditor.setSelection(quillEditor.getLength(), quillEditor.getLength() + 1)
			// this.insertingFlag = false
			return 'insertEmbed-true'
		},
		getMousePos(event) {
			// var e = event || window.event
			// var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft
			// var scrollY = document.documentElement.scrollTop || document.body.scrollTop
			// var x = e.pageX || e.clientX + scrollX
			// var y = e.screenY || e.clientY + scrollY
			const x = event.pageX
			const y = event.screenY
			//alert('x: ' + x + '\ny: ' + y);
			return { x: x, y: y }
		},
		handleImageClick(event) {
			const target = event.target
			event.stopPropagation()
			if (target.getAttribute('data') === null) {
				this.videoFlag = false
				this.audioFlag = false
			}
			const { x, y } = this.getMousePos(event)
			this.style = {
				left: `${x}px`,
				top: `${y}px`
			}
			switch (target.getAttribute('type')) {
				case 'image':
					this.imgResource = target.getAttribute('src')
					this.imgFlag = true
					break
				case 'audio':
					this.audioResource = target.getAttribute('data')
					this.audioFlag = true
					break
				case 'video':
					this.videoResource = target.getAttribute('data')
					this.videoFlag = true
					break
				default:
			}
		},
		openEditEvent(node) {
			this.fillInFlag = true
			this.fillInText = [...node.text().split('|')]
			this.node = node
		},
		fillInTextClear(index) {
			if (this.fillInText.length <= 1) {
				this.node.remove()
				this.fillInFlag = false
			}
			this.fillInText.splice(index, 1)
		},
		saveEditEvent() {
			let result = ''
			for (let i = 0; i < this.fillInText.length; i++) {
				this.fillInText[i] = this.fillInText[i].trim()
				if (this.fillInText.length == 1 && this.fillInText[0].answer == '') {
					result = '点击修改填空答案'
				}
				// 过滤空 input
				if (this.fillInText[i]) {
					if (result === '') {
						result += this.fillInText[i]
					} else {
						result += '|' + this.fillInText[i]
					}
				}
			}
			this.node.text(result)
			this.fillInFlag = false
		},
		updateContent: debounce(function (content) {
			this.contentCopy = content
			let delta = this.getContentsOps()
			this.$emit('changeContent', { content: this.contentCopy, delta })
			const answer = spansText(this.contentCopy)
			const body = spansTextEmpty(this.contentCopy)
			this.$emit('insertText', { answer, body })
		}, 200),
		getContentsOps() {
			let quillEditor = this.$refs[`editors_${this.id}`].quill
			const delta = quillEditor.getContents() // 获取 Delta 对象
			let opsList = []
			delta.ops.forEach(op => {
				if (op.insert && typeof op.insert === 'string') {
					opsList.push(op.insert)
				} else if (op.insert?.span) {
					opsList.push(op.insert.span.content)
				} else if (op.insert?.image) {
					opsList.push(op.insert.image.data)
				}
			})
			return opsList
		},
		onFocus() {
			this.focused = true
		},
		focusEditor() {
			this.$refs[`editors_${this.id}`].focus()
		},
		// 上传成功之后的回调,获取到链接
		customUpload({ response }) {},
		// 删除表单上传的file文件路径
		deleteUpload({ index, fileUrlData }) {
			fileUrlData.splice(index, 1)
		},
    /**
     * @param {IteratorResult<any>} gVal 迭代器结果
     * @param {Generator<any>} gRun 生成器实例
     */
    gLoop(gVal, gRun) {
      const { done } = gVal
      if (done) {
        this.closeDialog()
        return
      }
      this.gLoop(gRun.next(), gRun)
    },
    *getGen(arr) {
      const { richTextContentMultiple } = this.currentActiveIdObj
      for (const e of arr) {
        yield richTextContentMultiple(e)
      }
    },
    resourceDialogConfirmCallback(fileList) {
      if (this.tikuManager.activeID) {
        const { acceptFileType, urlData, insertFileListOnChange } = this.currentActiveIdObj
        // 如果传入了 insertFileListOnChange 回调函数，则不走富文本插入资源逻辑
        if (typeof insertFileListOnChange === 'function') {
          insertFileListOnChange(
            fileList.reduce((acc, cur) => {
              acc = [...acc, {
                ...cur,
                ossUri: cur.path.url,
                ossNode: cur.path.node,
              }]
              return acc
            }, [])
          )
          this.closeDialog()
          return
        }
        /* 用于插入富文本的多个资源 */
        const insertArr = fileList.reduce((acc, cur) => {
          acc = [
            ...acc,
            {
              fileType: acceptFileType,
              fileUrlData: urlData,
              response: {
                node: cur.path.node,
                uri: cur.path.url
              }
            }
          ]
          return acc
        }, [])
        /* 递归调用 richTextContentMultiple 插入富文本 */
        const gRun = this.getGen(insertArr)
        this.gLoop(gRun.next(), gRun)
      }
    },
		/**
		 * 打开弹窗并传入文件类型
		 * @param {'image' | 'video' | 'audio'} type 文件类型
		 */
    popup(type) {
            const typeMap = {
        image: 1,
        video: 3,
        audio: 2
      }
      const objProps = {
				'request-token': () => JSON.parse(window.localStorage.getItem('tokenInfo') || '{}').access_token,
        'subject-id': +this.$route.query.subjectId || +this.$route.params.sbid,
        'confirm-callback': this.resourceDialogConfirmCallback,
        'accept-file-type': () => [typeMap[type]]
      }
            // 渲染弹窗
      const dom = new ResourcesDialogShadowElement(objProps)
      this.$refs.dialogRefBox.appendChild(dom)
			this.tikuManager.objIdData[this.id].acceptFileType = type
      this.tikuManager.objIdData[this.id].resourceDialogShow = true
      this.tikuManager.objIdData[this.id].beforeUpload = validateCommon[type].beforeUpload
			this.tikuManager.objIdData[this.id].uploadAcceptFileType = validateCommon[type].uploadAcceptFileType
      this.tikuManager.activeID = this.id
      this.closeDialog = () => {
        this.$refs.dialogRefBox.removeChild(dom)
      }
		}
	},
	mounted() {
		window.addEventListener('scroll', () => {
			this.videoFlag = false
			this.audioFlag = false
		})
		this.$nextTick(() => {
			this.tikuManager.objIdData[this.id].richTextContentMultiple = this.richTextContentMultiple
			this.tikuManager.objIdData[this.id].deleteUpload = this.deleteUpload
		})
	},
	created() {
		this.tikuManager.objIdData = {
			...this.tikuManager.objIdData,
			[this.id]: {
				acceptFileType: '',
				deleteUpload: () => {},
				urlData: [],
				richTextContentMultiple: (_) => {},
        resourceDialogShow: false,
        beforeUpload: () => { },
        uploadAcceptFileType: ''
			}
		}
		setThis(this.openEditEvent)
	}
}
</script>
<style lang="scss" scoped>
/deep/ .el-upload {
	display: flex !important;
}
.dialog {
	/deep/ dialog-title {
		font-size: 18px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #323232;
	}
	/deep/ .el-dialog__body {
		// border-top: 2px solid #f8f8f8;
		// border-bottom: 2px solid #f8f8f8;
		margin: 1px 20px;
		display: flex;
		flex-wrap: wrap;
		align-items: baseline;
	}
	/deep/ .el-dialog__footer {
		margin-top: 24px;
		margin-bottom: 25px;
	}
	.fill-in-input {
		flex-basis: 32%;
		display: flex;
		align-items: center;
		padding-bottom: 13px;
	}
	.fill-in-input::after {
		content: '';
		display: block;
		height: 24px;
		width: 1px;
		background: #ebeef5;
		margin: 0 12px;
	}
}

.dialog-tip {
	font-size: 18px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: bold;
	color: #323232;
	margin-top: 63px;
	margin-bottom: 52px;
	text-align: center;
}
.dialog-title {
	font-size: 18px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
}
.vue-quill-editor-container {
	position: relative;
	/deep/ .ql-toolbar {
		display: none !important;
	}
	// 这里实现编辑富文本行内排序、但是br失效了
	/deep/ .ql-editor {
		// display: flex;
		// flex-wrap: wrap;
	}
	/deep/ .ql-editor p {
		display: inline-block;
		// 	// align-items: center;
		// 	// flex-wrap: wrap;
		word-break: break-all;
	}
	/deep/ .ql-editor::before {
		content: attr(data-placeholder);
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-style: normal;
		color: #cccccc;
		display: none;
	}
	.border-top {
		border-top: 1px solid #ccc;
	}
	.placeholder {
		position: absolute;
		top: -5px;
		left: 10px;
		pointer-events: none;
		font-size: 14px;
		color: #cccccc;
		background: white;
		z-index: 999;
		transition: 0.3s;
		padding: 0 5px;
		zoom: 0.8;
		height: 10px;
		display: flex;
		align-items: center;
		border-radius: 10px;
	}
	.placeholder.active {
		top: 20px;
		height: 10px;
		zoom: 1;
		display: flex;
		align-items: center;
		border-radius: 10px;
	}
	// .placeholder {
	// 	position: absolute;
	// 	top: 0;
	// 	left: 15px;
	// 	pointer-events: none;
	// 	font-size: 14px;
	// 	color: #cccccc;
	// 	transition: opacity 0.3s ease-in-out;
	// 	opacity: 0;
	// }
	// .placeholder.active {
	// 	opacity: 1;
	// }
	.vue-quill-editor.focused {
		/deep/ .border-top {
			border-color: #ff5e2a;
		}
		/deep/ .ql-container.ql-snow {
			border-color: #ff5e2a;
		}
	}
}

.flex-align-center {
	display: flex;
	align-items: center;
}

.icon-circle {
	width: 30px;
	height: 30px;
	background: #fff1f1;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.video {
	position: fixed;
	top: 0;
	left: 0;
	transform: translate(-42%, -150%);
}
</style>
